module.exports = __webpack_public_path__ + "img/logo-hkaa.31bd421f.png";